import type { Cuenta } from '../models/cuenta.model';

export type CuentaDistribuidorMarker = Pick<Cuenta, 'distribuidor'>;

/** Normaliza el flag `distribuidor` del API a `0` o `1`. */
export function resolveCuentaDistribuidor(cuenta: { distribuidor?: unknown } | null | undefined): 0 | 1 {
  return Number(cuenta?.distribuidor) === 1 ? 1 : 0;
}

/** Asegura `distribuidor` numérico en respuestas de cuenta (listado y detalle). */
export function normalizeCuentaDistribuidor<T extends CuentaDistribuidorMarker>(cuenta: T): T {
  const distribuidor = resolveCuentaDistribuidor(cuenta);
  if (cuenta.distribuidor === distribuidor) {
    return cuenta;
  }
  return { ...cuenta, distribuidor };
}
